import { Filter, FilterConfig, FilterTypes, IsFilterable } from "@/lib/filterable";
import { IVSelectItem } from "@/lib/interfaces/v-select-item.interface";
import { MrfiktivCompanyInformationViewModelGen } from "@/services/mrfiktiv/v1/data-contracts";
import { BackendResourceEnum } from "@/store/enum/authResourceEnum";
import { CompanyModule } from "@/store/modules/company.store";

/**
 * The types of companies
 */
export enum HandoverCompanyTypeEnum {
  OWNER = "owner",
  KEEPER = "keeper",
  NEW_KEEPER = "new_keeper",
  TENANT = "tenant",
  NEW_TENANT = "new_tenant",
  OTHER = "other"
}

@IsFilterable
class CompanyInformationBase implements MrfiktivCompanyInformationViewModelGen {
  @FilterConfig({ displayName: "objects.handover.company.name", type: FilterTypes.STRING })
  companyName?: string;

  @FilterConfig({
    displayName: "objects.handover.company.type",
    type: FilterTypes.ENUM,
    config: {
      items: Object.values(HandoverCompanyTypeEnum).map((e) => {
        return {
          text: `enums.HandoverCompanyTypeEnum.${e}`,
          value: e
        } as IVSelectItem;
      }),
      itemValue: "value"
    }
  })
  companyType?: string;

  @FilterConfig({ displayName: "objects.handover.company.email", type: FilterTypes.STRING })
  email?: string;

  @FilterConfig({ displayName: "objects.handover.company.phone", type: FilterTypes.STRING })
  phone?: string;

  @FilterConfig({
    displayName: "objects.handover.company.companyId",
    type: FilterTypes.OBJECT_ID,
    config: {
      itemCallback: () => CompanyModule.entities,
      mapItemToComponent: (item) => ({ item }),
      itemValue: "id",
      component: "refs-company",
      refType: BackendResourceEnum.COMPANY
    }
  })
  companyId?: string;

  get dto() {
    return {
      companyName: this.companyName,
      companyType: this.companyType as HandoverCompanyTypeEnum,
      email: this.email,
      phone: this.phone,
      companyId: this.companyId || null
    };
  }

  constructor(contact?: Partial<ICompanyInformation>) {
    this.companyName = contact?.companyName ?? "";
    this.companyType = contact?.companyType;
    this.email = contact?.email ?? "";
    this.phone = contact?.phone ?? "";
    this.companyId = contact?.companyId;
  }
}

type ICompanyInformation = CompanyInformationBase;
const CompanyInformation = Filter.createForClass(CompanyInformationBase);

export { CompanyInformation, ICompanyInformation };
